"use strict";
/**
 * 开通引导契约（P1-25）。
 *
 * P1-24 之后，客户注册完就有一个能打开的站点地址。但那套东西**全部是从邮箱
 * 派生的**：站点名是 `zhang.wei`，地址是 `zhang-wei.icetus.net`，语言是 en。
 * 客户登录后要做的第一件事就是把这三样改成自己的，然后是"发布"——
 * 而三个页面默认是 draft，他不发布，那个地址就一直是 404。
 *
 * 所以这个契约同时承担两个用途：
 *   1) 引导：站点叫什么、地址是什么、给谁看（语言）；
 *   2) 完成度：还差什么才能算"上线了"（发布、联系方式、第一个商品、自有域名）。
 *
 * 两者共用一次读取。分成两个接口的话，卡片上"已完成 2/6"和表单里的值
 * 会在两次刷新之间对不上，客户会以为自己的修改没保存。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_CHECKLIST_KEYS = void 0;
exports.ONBOARDING_CHECKLIST_KEYS = [
    'email',
    'published',
    'contact',
    'product',
    'domain',
];
//# sourceMappingURL=onboarding.js.map